
import Swal from "sweetalert2";

export default {

    /**
     * Show a modal alert with a title, message, and type
     * 
     * @param {*} htmlContent HTML content to be displayed in the alert
     * @param {*} onClose Callback function to be executed when the alert is closed
     * @param {*} alertTitle Title of the alert. Default is 'Success'
     * @param {*} alertType Type of the alert (error, info, success). Default is 'success'
     */
    uiAlert(htmlContent, onClose, alertTitle, alertType) {
        var _title = (typeof(alertTitle)==='undefined'?'Success':alertTitle);
	    var _type = (typeof(alertType)==='undefined'?'success':alertType);

        Swal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            title: _title,
            html: htmlContent,
            icon: _type,
            showCancelButton: false,
            confirmButtonColor: '#007bff',
            confirmButtonText: "OK"
        }).then((result) => {
            if (result.isConfirmed) {
                if (onClose) onClose()
            }
        });
    },

    /**
     * Show a toast notification with a message, type, and optional onClose callback
     * 
     * @param {*} message Message to be displayed in the toast
     * @param {*} type Type of the toast (error, info, success). Default is 'info'
     * @param {*} onClose Callback function to be executed when the toast is closed
     */
    uiToast(message, type = 'info', onClose = null) {
        Swal.fire({
            title: message,
            icon: type,
            showConfirmButton: false,
            toast: true,
            position: 'top',
            timer: 3000,
            timerProgressBar: true,
            customClass: {
                popup: 'swal2-toast'
            },
            onClose: () => {
                if (onClose) onClose()
            }
        })
    },

    /**
     * Show a confirmation dialog with a message and optional onConfirm and onCancel callbacks
     * @param {confirmHtml} message 
     * @param {Function} confirmTitle 
     * @param {object} extraParams 
     */
    uiConfirm(confirmHtml, confirmTitle, extraParams) {
        var _extraParams = (typeof(extraParams) === 'undefined' ? {} : extraParams);
        var _confirmButtonText = (typeof(_extraParams.confirmButtonText) === 'undefined' ?
                "Confirm" : _extraParams.confirmButtonText);
        var _cancelButtonText = (typeof(_extraParams.cancelButtonText) === 'undefined' ?
                "Cancel" : _extraParams.cancelButtonText);
        
        var confirmCallback = null;
        if (typeof(_extraParams) == 'function') {
            confirmCallback = _extraParams;
            _extraParams = {};
        } else {
            confirmCallback = _extraParams.onConfirm;
        }
        
        Swal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            title: confirmTitle,
            html: confirmHtml,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: _confirmButtonText,
            cancelButtonText: _cancelButtonText,
            showLoaderOnConfirm: true,
            preConfirm: function() {
                return new Promise(function(resolve) {
                    if (typeof(confirmCallback)==='function') {
                        confirmCallback(resolve, function(msg) {
                            Swal.disableLoading();
                            Swal.showValidationMessage(msg);
                        });
                    } else {
                        resolve();
                    }
                });
            },
        }).then((result) => {
            if (!result.value) {
                if (typeof(_extraParams.onCancel) == 'function') {
                    _extraParams.onCancel();
                }
            }
        });
    },

    /**
     * Get browser and operating system information from the user agent string
     * @return {Object} An object containing browser name, version, OS name, version, and user agent string
     */
    getBrowserInfo() {
        const userAgent = navigator.userAgent;
        let browserName = 'Unknown';
        let browserVersion = 'Unknown';
        let osName = 'Unknown';
        let osVersion = 'Unknown';

        // Detect browser
        if (userAgent.indexOf('Firefox') > -1) {
            browserName = 'Firefox';
            browserVersion = userAgent.match(/Firefox\/(\d+)/)?.[1] || 'Unknown';
        } else if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Chromium') === -1) {
            browserName = 'Chrome';
            browserVersion = userAgent.match(/Chrome\/(\d+)/)?.[1] || 'Unknown';
        } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
            browserName = 'Safari';
            browserVersion = userAgent.match(/Version\/(\d+)/)?.[1] || 'Unknown';
        } else if (userAgent.indexOf('Edg') > -1) {
            browserName = 'Edge';
            browserVersion = userAgent.match(/Edg\/(\d+)/)?.[1] || 'Unknown';
        } else if (userAgent.indexOf('Trident') > -1) {
            browserName = 'Internet Explorer';
            browserVersion = userAgent.match(/rv:(\d+)/)?.[1] || 'Unknown';
        } else if (userAgent.indexOf('OPR') > -1 || userAgent.indexOf('Opera') > -1) {
            browserName = 'Opera';
            browserVersion = userAgent.match(/OPR\/(\d+)|Opera\/(\d+)/)?.[1] || 'Unknown';
        }

        // Detect operating system
        if (userAgent.indexOf('Win') > -1) {
            osName = 'Windows';
            if (userAgent.indexOf('Windows NT 10.0') > -1) osVersion = '10/11';
            else if (userAgent.indexOf('Windows NT 6.3') > -1) osVersion = '8.1';
            else if (userAgent.indexOf('Windows NT 6.2') > -1) osVersion = '8';
            else if (userAgent.indexOf('Windows NT 6.1') > -1) osVersion = '7';
        } else if (userAgent.indexOf('Mac') > -1) {
            osName = 'macOS';
            osVersion = userAgent.match(/Mac OS X ([0-9_]+)/)?.[1]?.replace(/_/g, '.') || 'Unknown';
        } else if (userAgent.indexOf('X11') > -1) {
            osName = 'Linux';
            osVersion = 'Unknown';
        } else if (userAgent.indexOf('Android') > -1) {
            osName = 'Android';
            osVersion = userAgent.match(/Android ([0-9.]+)/)?.[1] || 'Unknown';
        } else if (userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1) {
            osName = 'iOS';
            osVersion = userAgent.match(/OS ([0-9_]+)/)?.[1]?.replace(/_/g, '.') || 'Unknown';
        }

        return {
            browser: browserName,
            browserVersion: browserVersion,
            os: osName,
            osVersion: osVersion,
            userAgent: userAgent
        };
    }
}
